export const AUTH_STATES = {
  IDLE: "idle",
  RESTORING: "restoring",
  AUTHENTICATED: "authenticated",
  UNAUTHENTICATED: "unauthenticated",
  LOGGING_IN: "logging_in",
  ERROR: "error",
};

export const AUTH_EVENTS = {
  RESTORE: "RESTORE",
  RESTORE_SUCCESS: "RESTORE_SUCCESS",
  RESTORE_FAIL: "RESTORE_FAIL",
  LOGIN_START: "LOGIN_START",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAIL: "LOGIN_FAIL",
  LOGOUT: "LOGOUT",
};

export const initialState = {
  status: AUTH_STATES.IDLE,
  user: null,
  photoURL: null,
  error: null,
};

export function authReducer(state, action) {
  const next = _authReducer(state, action);

  return next;
}

function _authReducer(state, action) {
  switch (action.type) {
    case AUTH_EVENTS.RESTORE:
      if (
        state.status === AUTH_STATES.LOGGING_IN ||
        state.status === AUTH_STATES.AUTHENTICATED
      ) {
        return state;
      }
      return {
        ...state,
        status: AUTH_STATES.RESTORING,
      };
    case AUTH_EVENTS.RESTORE_SUCCESS:
      if (state.status === AUTH_STATES.LOGGING_IN) {
        return state;
      }
      return {
        status: AUTH_STATES.AUTHENTICATED,
        user: action.user,
        photoURL: action.photoURL ?? null,
        error: null,
      };
    case AUTH_EVENTS.RESTORE_FAIL:
      if (
        state.status === AUTH_STATES.LOGGING_IN ||
        state.status === AUTH_STATES.AUTHENTICATED
      ) {
        return state;
      }
      return {
        status: AUTH_STATES.UNAUTHENTICATED,
        user: null,
        photoURL: null,
        error: null,
      };
    case AUTH_EVENTS.LOGIN_START:
      return {
        ...state,
        status: AUTH_STATES.LOGGING_IN,
      };
    case AUTH_EVENTS.LOGIN_SUCCESS:
      return {
        status: AUTH_STATES.AUTHENTICATED,
        user: action.user,
        photoURL: action.photoURL ?? null,
      };
    case AUTH_EVENTS.LOGIN_FAIL:
      return {
        status: AUTH_STATES.ERROR,
        error: action.error,
      };
    case AUTH_EVENTS.LOGOUT:
      return {
        status: AUTH_STATES.UNAUTHENTICATED,
        user: null,
        photoURL: null,
        error: null,
      };
    default:
      return state;
  }
}
